/* eslint-disable */
export const user = {
    id    : 'c2dc25e4-8ebb-5251-98ce-ce14608dd9c7',
    name  : 'iApply Guest User',
    firstName: 'Guest',
    email : 'guest01@iapply.com.au',
    emailHash: '7ac8500d36d909952ce44738320ae4c8',
    avatar: 'images/avatars/male-01.jpg',
    status: 'online'
};
